import { ACCESS_DENIED_MESSAGE } from '../../lib/dataverse';
import styles from './AccessNotice.module.css';

/**
 * Amber "your access isn't set up" card, shown instead of a blank screen or a
 * raw error when Dataverse returns 403. See
 * design-system/ACCESS-EMPTY-STATE-PATTERN.md.
 *
 * Deliberately amber (not red): it's a setup gap with a known fix, not a
 * fault. No Retry button — retrying can't help.
 */
export function AccessNotice() {
  return (
    <div className={styles.notice} role="status">
      {ACCESS_DENIED_MESSAGE}
    </div>
  );
}
